/* Keep the original theme menu behaviour; only choose the layout that fits. */
(() => {
  if (window.MBCompactHeader) { window.MBCompactHeader.init(document); return; }
  const instances = new Map();
  function init(root) {
    const headers = [];
    if (root.matches && root.matches('theme-header.mb-compact')) headers.push(root);
    root.querySelectorAll('theme-header.mb-compact').forEach(h => headers.push(h));
    headers.forEach(header => {
      if (instances.has(header)) return;
      const inner = header.querySelector(':scope > .row > .columns');
      const menu = header.querySelector('.full-menu');
      const list = menu && menu.querySelector('.thb-full-menu');
      const toggle = header.querySelector('.mobile-toggle');
      if (!inner || !menu || !list || !toggle) return;
      let frame = 0;
      const update = () => {
        frame = 0;
        if (!header.isConnected) return;
        // Measure the intrinsic top-level row, excluding absolutely positioned dropdowns.
        // The hidden menu remains measurable and visible dropdowns are never clipped.
        const needsDrawer = window.innerWidth < 1200 || list.offsetWidth > inner.clientWidth - 2;
        const changed = header.classList.contains('mb-compact--drawer') !== needsDrawer;
        const focusInMenu = menu.contains(document.activeElement);
        const focusOnToggle = toggle === document.activeElement;
        header.classList.toggle('mb-compact--drawer', needsDrawer);
        if (needsDrawer && focusInMenu) toggle.focus();
        menu.inert = needsDrawer;
        if (needsDrawer) menu.setAttribute('aria-hidden', 'true');
        else menu.removeAttribute('aria-hidden');
        if (changed && !needsDrawer) {
          const drawer = document.getElementById('mobile-menu');
          if (drawer && typeof OverlayManager !== 'undefined' && OverlayManager.isOpen(drawer)) {
            OverlayManager.close(drawer);
          }
          if (focusOnToggle || toggle === document.activeElement) {
            const firstLink = list.querySelector('a');
            if (firstLink) firstLink.focus();
          }
        }
        if (changed) {
          // These are the existing theme's height/position measurement methods.
          ['setHeaderOffset', 'setHeaderHeight', 'setHeaderBottom'].forEach(method => {
            if (typeof header[method] === 'function') header[method]();
          });
        }
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(schedule) : null;
      if (observer) { observer.observe(inner); observer.observe(list); }
      window.addEventListener('resize', schedule, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
      instances.set(header, () => {
        if (observer) observer.disconnect();
        window.removeEventListener('resize', schedule);
        cancelAnimationFrame(frame);
        instances.delete(header);
      });
      update();
    });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, header) => {
      if (event.target.contains(header)) cleanup();
    });
  });
  window.MBCompactHeader = { init };
  init(document);
})();
